import React from 'react';
import TextField from '@mui/material/TextField';
import UiFieldWrapper from './UiFieldWrapper';
import UiBaseField from './UiBaseField';
import { getFieldData } from './UiFieldHelpers';
type IPropsUiTextarea = {
}
export const UiTextareaField = (props: UiBaseField & IPropsUiTextarea) => {
    const {error, name, value, onChange} = getFieldData(props);

    return (
        <React.Fragment>
            <UiFieldWrapper name="ui-textearea-field" {...props}>
                <span className="ui-text-field__field  ui-field__field">
                    <TextField
                        id={props.id}
                        fullWidth
                        label={props.label}
                        variant="outlined"
                        value={value}
                        disabled={props.disabled}
                        name={name}
                        onChange={onChange}
                        onFocus={props.onFocus}
                        onBlur={props.onBlur}
                        error={error.hasError}
                        helperText={error.hasError ? error.errorMessage : null}
                        multiline
                        placeholder={props.placeholder}
                        inputProps={props.inputProps}
                    />
                </span>
            </UiFieldWrapper>
        </React.Fragment>
    )
}
export default UiTextareaField